import { ModalProperties } from './reducer';

export enum ModalTypeKeys {
    SHOW_MODAL = 'modal/SHOW_MODAL',
    SHOW_CANCEL_EXPLANATION_OF_GRADES = 'modal/SHOW_CANCEL_EXPLANATION_OF_GRADES',
    SHOW_REQUEST_EXPLANATION_OF_GRADES = 'modal/SHOW_REQUEST_EXPLANATION_OF_GRADES',
    SHOW_EDIT_EXPLANATION_DEADLINE = 'modal/SHOW_EDIT_EXPLANATION_DEADLINE',
    SHOW_SEND_EXPLANATION_TO_CANDIDATE = 'modal/SHOW_SEND_EXPLANATION_TO_CANDIDATE',
    SHOW_SEND_EXPLANATION_TO_ALL_CANDIDATES = 'modal/SHOW_SEND_EXPLANATION_TO_ALL_CANDIDATES',
    CLOSE_MODAL = 'modal/CLOSE_MODAL',
    SHOW_CONFIRM_CANCEL_RECORDING = 'modal/SHOW_CONFIRM_CANCEL_RECORDING',
    SHOW_CONFIRM_REDO_RECORDING = 'modal/SHOW_CONFIRM_REDO_RECORDING',
    SHOW_SET_FILENAME_FOR_RECORDING = 'modal/SHOW_SET_FILENAME_FOR_RECORDING',
}

export interface ShowModal {
    properties: ModalProperties;
    type: ModalTypeKeys.SHOW_MODAL;
}

export interface ShowCancelExplanationOfGrades {
    hitData: any;
    type: ModalTypeKeys.SHOW_CANCEL_EXPLANATION_OF_GRADES;
}

export interface ShowRequestExplanationOfGrades {
    hitData: any;
    type: ModalTypeKeys.SHOW_REQUEST_EXPLANATION_OF_GRADES;
}

export interface ShowEditExplanationDeadline {
    type: ModalTypeKeys.SHOW_EDIT_EXPLANATION_DEADLINE;
}

export interface ShowSendExplanationOfGradesToCandidate {
    featureId: string;
    type: ModalTypeKeys.SHOW_SEND_EXPLANATION_TO_CANDIDATE;
}

export interface ShowSendExplanationOfGradesToAllCandidates {
    featureId: string;
    type: ModalTypeKeys.SHOW_SEND_EXPLANATION_TO_ALL_CANDIDATES;
}

export interface CloseModal {
    type: ModalTypeKeys.CLOSE_MODAL;
}

export interface ShowConfirmCancelRecording {
    type: ModalTypeKeys.SHOW_CONFIRM_CANCEL_RECORDING;
}

export interface ShowConfirmRedoRecording {
    type: ModalTypeKeys.SHOW_CONFIRM_REDO_RECORDING;
}

export interface ShowSetFilenameForRecording {
    type: ModalTypeKeys.SHOW_SET_FILENAME_FOR_RECORDING;
    defaultFilename: string;
}

export type ModalAction =
    ShowRequestExplanationOfGrades | ShowEditExplanationDeadline
    | ShowCancelExplanationOfGrades | ShowModal | CloseModal | ShowConfirmCancelRecording
    | ShowConfirmRedoRecording | ShowSetFilenameForRecording
    | ShowSendExplanationOfGradesToCandidate | ShowSendExplanationOfGradesToAllCandidates;

export const closeModal = (): CloseModal => ({
    type: ModalTypeKeys.CLOSE_MODAL,
});

export const showModal = (properties: ModalProperties): ShowModal => ({
    properties,
    type: ModalTypeKeys.SHOW_MODAL,
});

export const showEditExplanationDeadline = (): ShowEditExplanationDeadline => ({
    type: ModalTypeKeys.SHOW_EDIT_EXPLANATION_DEADLINE,
});

export const showCancelExplanationOfGrades = (hitData: any): ShowCancelExplanationOfGrades => ({
    hitData,
    type: ModalTypeKeys.SHOW_CANCEL_EXPLANATION_OF_GRADES,
});

export const showRequestExplanationOfGrades = (hitData: any): ShowRequestExplanationOfGrades => ({
    hitData,
    type: ModalTypeKeys.SHOW_REQUEST_EXPLANATION_OF_GRADES,
});

export const showConfirmCancelRecording = (): ShowConfirmCancelRecording => ({
    type: ModalTypeKeys.SHOW_CONFIRM_CANCEL_RECORDING,
});

export const showConfirmRedoRecording = (): ShowConfirmRedoRecording => ({
    type: ModalTypeKeys.SHOW_CONFIRM_REDO_RECORDING,
});

export const showSetFilenameForRecording = (defaultFilename: string): ShowSetFilenameForRecording => ({
    defaultFilename,
    type: ModalTypeKeys.SHOW_SET_FILENAME_FOR_RECORDING,
});

export const showSendExplanationOfGradesToCandidate = (featureId: string): ShowSendExplanationOfGradesToCandidate => ({
    featureId,
    type: ModalTypeKeys.SHOW_SEND_EXPLANATION_TO_CANDIDATE,
});

export const showSendExplanationOfGradesToAllCandidates = (featureId: string): ShowSendExplanationOfGradesToAllCandidates => ({
    featureId,
    type: ModalTypeKeys.SHOW_SEND_EXPLANATION_TO_ALL_CANDIDATES,
});
